import { Component } from '@angular/core';

@Component({
	selector: 'app-timetable-hours',
	templateUrl: './timetable-hours.component.html',
	styleUrls: ['./timetable-hours.component.css'],
})
export class TimetableHoursComponent {
	constructor() {}
}
